import { type FC, useCallback } from 'react';

import { applyEntityAclsBulk } from '../../../ducks/common_acls/thunks';
import type { AclsContextItem } from '../../../panels/entity_acls/types';
import { useAppDispatch } from '../../../store/react_redux_typed';
import PromiseConfirmModal from '../../../ui/controls_modal/promise_confirm_modal/promise_confirm_modal';
import { formatObjectDefinitionLabel } from '../../../utils/object_type';
import withContextItems from '../context_items_hoc';
import type {
  ContextItemsHocProps,
  ModalComponentProps,
} from '../modals_manager/types';

type Props = ContextItemsHocProps<AclsContextItem> & ModalComponentProps;

const AclsApplyToContentModal: FC<Props> = (props) => {
  const { item } = props;

  const dispatch = useAppDispatch();
  const confirmAction = useCallback(
    () => () => {
      if (!item.aclsType || !item.aclsObjectId) {
        return Promise.resolve();
      }

      return dispatch(
        applyEntityAclsBulk(item.aclsType, [item.aclsObjectId], {
          user_ids: 'user_id' in item ? [item.user_id] : [],
          group_ids: 'group_id' in item ? [item.group_id] : [],
          permissions: item.permissions,
        }),
      );
    },
    [item],
  );

  if (!item?.aclsType) {
    return null;
  }

  const content = formatObjectDefinitionLabel(
    [{ object_type: item.aclsType, id: '' }],
    ({ objectName }) => ({
      single: `You are about to apply permissions to all the content in this ${objectName}. Do you want to continue?`,
      multiple: `You are about to apply permissions to all the content in these ${objectName}. Do you want to continue?`,
    }),
  );

  return (
    <PromiseConfirmModal
      {...props}
      id={item.id}
      headerText="Permanently Apply to Content"
      confirmButtonText="Apply"
      confirmAction={confirmAction}
      variant="success"
    >
      {content}
    </PromiseConfirmModal>
  );
};

export default withContextItems(AclsApplyToContentModal);
